import { render, staticRenderFns } from "./EditCourse.vue?vue&type=template&id=18f38356&scoped=true"
import script from "./EditCourse.vue?vue&type=script&lang=js"
export * from "./EditCourse.vue?vue&type=script&lang=js"
import style0 from "./EditCourse.vue?vue&type=style&index=0&id=18f38356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f38356",
  null
  
)

export default component.exports